import { Component, inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { NgIf } from '@angular/common';
import { DropdownComponent } from '../../../shared/components/dropdown/dropdown.component';
import { TextareaComponent } from '../../../shared/components/textarea/textarea.component';
import { InputComponent } from '../../../shared/components/input/input.component';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import {
  ContactFormPageResponse,
  ContactFormRequest,
  ContactFormResponse,
  ContactFormService,
} from '../../../generated';
import { ToastService } from '../../../shared/components/toast-wrapper/toast-service';
import { catchError, of } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';

enum SubjectOptions {
  CONSULTING = 'CONSULTING',
  SOFTWARE_DEVELOPMENT = 'SOFTWARE_DEVELOPMENT',
  INTEGRATION_DEVOPS = 'INTEGRATION_DEVOPS',
  AUTOMATION = 'AUTOMATION',
  AI = 'ARTIFICIAL_INTELLIGENCE',
  INQUIRY = 'INQUIRY',
  CONSULTATION = 'CONSULTATION',
  QUOTATION_REQUEST = 'QUOTATION_REQUEST',
  FEEDBACK = 'FEEDBACK',
  OTHERS = 'OTHERS',
}

@Component({
  selector: 'app-contact-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgIf,
    DropdownComponent,
    TextareaComponent,
    InputComponent,
    ButtonComponent,
    TranslatePipe,
  ],
  templateUrl: './contact-form.component.html',
  styleUrl: './contact-form.component.scss',
})
export class ContactFormComponent implements OnInit {
  contactForm: FormGroup;
  contactList: ContactFormRequest[] | undefined = [];
  private contactFormService = inject(ContactFormService);
  private toastService = inject(ToastService);

  subject: SubjectOptions[] = [
    SubjectOptions.CONSULTING,
    SubjectOptions.SOFTWARE_DEVELOPMENT,
    SubjectOptions.INTEGRATION_DEVOPS,
    SubjectOptions.AUTOMATION,
    SubjectOptions.AI,
    SubjectOptions.INQUIRY,
    SubjectOptions.CONSULTATION,
    SubjectOptions.QUOTATION_REQUEST,
    SubjectOptions.FEEDBACK,
    SubjectOptions.OTHERS,
  ];

  submitted = false;

  constructor(private fb: FormBuilder) {
    this.contactForm = this.fb.group({
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      subject: '',
      message: '',
    });
  }

  ngOnInit(): void {
    this.contactForm = this.fb.group({
      firstname: ['', [Validators.required, Validators.minLength(2)]],
      lastname: ['', [Validators.required, Validators.minLength(2)]],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, Validators.pattern(/^\+?\d{7,15}$/)]],
      subject: ['', Validators.required],
      message: ['', [Validators.required, Validators.minLength(10)]],
    });

    this.contactFormService
      .getContactForms()
      .subscribe((r: ContactFormPageResponse) => {
        this.contactList = r.content;
      });
  }

  get f() {
    return this.contactForm.controls;
  }

  onSubmit(): void {
    this.submitted = true;

    if (this.contactForm.invalid) {
      return;
    }

    this.contactFormService
      .createContactForm(this.contactForm.value)
      .pipe(
        catchError((err: any) => {
          this.toastService.show('error', 'Contact form submission failed.', {
            duration: 8000,
          });
          return of(null); // return fallback value to complete observable
        })
      )
      .subscribe((response: ContactFormResponse | null) => {
        if (!response) {
          return;
        } // prevents logging null fallback
        this.toastService.show('success', 'Message sent successfully!');
      });

    this.contactForm.reset();
    this.submitted = false;
  }

  inputOnChange(event: any) {
    console.log('Input changed:', event);
  }
}
